import React, { useEffect, useState, useMemo } from 'react';
import { Avatar } from '@mui/material';
import Box from '@mui/material/Box';

export default function CategoryIllustration({ images, hover }: any) {
    const [activeImage, setActiveImage] = useState('');
    const [isLoaded, setIsLoaded] = useState(false);

    // Memoize image sources to avoid unnecessary re-renders
    const initialImage = useMemo(() => images?.initial?.src, [images]);
    const hoverImage = useMemo(() => images?.hover?.src, [images]);

    // Preload images and switch to them after they are loaded
    useEffect(() => {
        let isMounted = true;

        const preloadImage = (src: string) => {
            if (!src) return;
            const img = new Image();
            img.src = src;
            img.onload = () => {
                if (isMounted) {
                    setActiveImage(src);
                    setIsLoaded(true);
                }
            };
        };

        // Set initial image
        setActiveImage(initialImage);
        setIsLoaded(true);

        // Preload hover image if available
        if (hoverImage) {
            preloadImage(hoverImage);
        }

        // Cleanup on unmount
        return () => {
            isMounted = false;
        };
    }, [initialImage, hoverImage]);

    return (
        <Box
            component={Avatar}
            variant="square"
            width={1}
            height={1}
            marginBottom={2}
            src={hover ? hoverImage || initialImage : initialImage}
            sx={{
                height: '130px',
                objectFit: 'contain',
                transition: 'opacity 0.5s ease-in-out',
                opacity: isLoaded ? 1 : 0, // Opacity set to 0 until image is loaded
            }}
        />
    );
}
